import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import { required } from '../../../utils/validation';
import styles from './BulkUploadFileForm.styles';

import AddForm from '../addform/AddForm';
import FormField from '../formfield/FormField';

export class BulkUploadFileForm extends Component {
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.file !== this.props.file &&
      nextProps.file &&
      nextProps.file.length
    ) {
      setTimeout(this.props.handleSubmit(this.props.onSubmit));
    }
  }
  shouldComponentUpdate(nextProps) {
    return false;
  }
  render() {
    return (
      <AddForm styles={styles.form}>
        <div>
          <Translate value="add.bulkUpload.format" />&nbsp;
          <a className={css(styles.link)} href="/files/Sample.csv">
            <Translate value="add.bulkUpload.sample" />
          </a>
          <div className={css(styles.note)}><Translate value="add.bulkUpload.note"/></div>
        </div>
        <Field
          name="file"
          type="file"
          component={FormField}
          dropzoneOptions={{
            accept: '.csv',
            multiple: false,
            maxSize: 26214400
          }}
          validate={[required('file')]}
        />
      </AddForm>
    );
  }
}

const selector = formValueSelector('bulkupload');
const mapStateToProps = state => {
  return { file: selector(state, 'file') };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'bulkupload'
  })(BulkUploadFileForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/bulkupload/BulkUploadFileForm.js